import React from 'react'
import { FileSymlinkFileIcon } from '@primer/octicons-react'

const ProposalBox = ({ pdf, nombre }) => {
  return (
    <div className="p-4 mt-4 bg-white">
      <h4 className="block mb-2 font-sans text-sm uppercase">Programa</h4>
      <p>
        Este es el{' '}
        <strong>programa de candidatura a la Convención Constitucional</strong>{' '}
        que <strong>{nombre}</strong> subió en su postulación al{' '}
        <strong>Servel</strong>.
      </p>
      <div className="text-right">
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-6 py-2 text-white transition-all duration-500 ease-in-out rounded-full bg-azul border-azul hover:bg-rojo"
          href={pdf}>
          <FileSymlinkFileIcon size={16} /> Ver Propuesta
        </a>
      </div>
    </div>
  )
}

export default ProposalBox
